import { defineStore } from "pinia"
// import fetchWP from '@/utils/fetchWP'
import { useAppStore } from './app'

// using eval to bypass compile warning/errors
// const req = new fetchWP({
//     restURL: eval('lead_dialer_vars.api.url'),
//     restNonce: eval('lead_dialer_vars.api.nonce')
// })

export const useUserStore = defineStore("user", {
    state: () => {
        return {
            userdata: {},
            fetched_user: false,
            twilio: {
                sid: "",
                token: "",
                apiKey: "",
                apiSecret: "",
                applicationSid: ""
            },
            current_phone_number: {},
            twilio_error: false,
            show_user_settings: false,
            saving_user_settings: false,
            audio_files: [],
            audio_files_loading: false,
            app: null,
            logo_url: ""
        }
    },
    actions: {
        hasRole(role) {
            if(!this.userdata?.roles)
                return false
            return this.userdata?.roles.includes(role)
        },
        hasCapability(capability) {
            return this.userdata?.allcaps?.manage_brand ?? false
        },
        hasSubscription() {
            return this.userdata.membership && this.userdata.membership.length
        },
        fetchUser(force = false) {
            //only get once
            if(this.fetched_user)
                return
            this.fetched_user = true
            
            this.app = useAppStore()
            return this.app.req.get('user/settings')
            .then(data => {
                this.userdata = data.user_data
                if(typeof data.dialer_user_settings != "string")
                    this.twilio = data.dialer_user_settings
                if(data.current_phone_number != "")
                    this.current_phone_number = data.current_phone_number
                // if(data.logo_url != "")
                //     this.logo_url = data.logo_url
                return
            })
            .catch(error => {
                // window.location = "/wp-login.php?redirect_to="+escape(window.location.href)
                this.app.show_login_dialog = true
            })
        },
        saveUserSettings() {
            this.app = useAppStore()
            this.saving_user_settings = true
            
            this.app.req.post('user/settings', this.twilio)
                .then(data => {
                    // this.show_user_settings = false
                    this.saving_user_settings = false
                    this.app.showSuccess("Settings Saved")
                    this.fetchUser()
                })
                .catch(error => {
                    //display errors
                    this.app.showError(error.message)
                    this.saving_user_settings = false
                })
        },
        saveCurrentPhoneNumber(phone_number) {
            this.current_phone_number = phone_number
            this.app.req.post('user/meta', {key: 'current_phone_number', value:phone_number})
        },
        fetchAudioFiles() {
            this.audio_files_loading = true
            this.app.req.get('user/audio_files')
                .then(data => {
                    this.audio_files = data.audio_files
                    this.audio_files_loading = false
                })
        },
        deleteAudioFile(file) {
            console.log("delete", file)
            this.audio_files_loading = true
            this.app.delete(`user/audio_files/${file.ID}`)
                .then(response => {
                    this.audio_files = response.data.audio_files
                    this.audio_files_loading = false
                })
        },
        isAdmin: function() {
            return this.userdata.roles.includes('administrator') || this.userdata.roles.includes('editor')
        },
    }
})